import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

// Após um deploy, uma aba antiga pode tentar carregar um chunk que não existe
// mais ("Failed to fetch dynamically imported module"). Recarrega uma vez.
window.addEventListener('vite:preloadError', (event) => {
	const key = 'plumaa:preload-error-reload';
	if (sessionStorage.getItem(key)) return;
	sessionStorage.setItem(key, '1');
	event.preventDefault();
	window.location.reload();
});

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
	<StrictMode>
		<HelmetProvider>
			<App />
		</HelmetProvider>
	</StrictMode>,
);
